import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="container center">
        <h1>{t("page_not_found.title")}</h1>
        <Link to="/">{t("page_not_found.link")}</Link>
      </div>
    </>
  );
};

export default NotFound;
